<div class="container d-flex flex-column register-dialog-container">
    <header class="container-header d-flex justify-content-between align-items-center mb-4">
        <h3>{{ 'fingerprint.register' | translate }}</h3>
        <button type="button" mat-stroked-button (click)="startScan()" class="m-button-primary s-md" [disabled]="isLoading">
            <mat-icon>fingerprint</mat-icon> {{ 'fingerprint.start_scan' | translate }}
        </button>
    </header>

    <div class="content flex-grow-1">
        <div class="m-container p-0 mb-4">
            <div class="row">
                <!-- left finger print -->
                <div class="col-6 px-0 text-left">
                    <p class="side-title">{{ 'fingerprint.left_side' | translate }}</p>

                    <div class="px-1">
                        <div class="fingerprint-list" *ngIf="leftFingers.length > 0">
                            <div class="finger-card p-3 mb-2 border rounded d-flex align-items-center justify-content-between" *ngFor="let item of leftFingers">
                                <div>
                                    <span class="badge badge-primary mr-2">Index {{ item.finger_index }}</span>
                                    <span>{{ item.side }}</span>
                                </div>
                                <span class="text-success d-flex align-items-center">
                                    <mat-icon class="mr-1">check_circle</mat-icon> {{ item.quality }}%
                                </span>
                            </div>
                        </div>

                        <div *ngIf="leftFingers.length === 0" class="d-flex justify-content-start px-5">
                            <app-empty-list size="small" [isEmpty]="true"></app-empty-list>
                        </div>
                    </div>
                </div>

                <!-- right finger print -->
                <div class="col-6 px-0 text-left">
                    <p class="side-title">{{ 'fingerprint.right_side' | translate }}</p>

                    <div class="px-1">
                        <div class="fingerprint-list" *ngIf="rightFingers.length > 0">
                            <div class="finger-card p-3 mb-2 border rounded d-flex align-items-center justify-content-between" *ngFor="let item of rightFingers">
                                <div>
                                    <span class="badge badge-primary mr-2">Index {{ item.finger_index }}</span>
                                    <span>{{ item.side }}</span>
                                </div>
                                <span class="text-success d-flex align-items-center">
                                    <mat-icon class="mr-1">check_circle</mat-icon> {{ item.quality }}%
                                </span>
                            </div>
                        </div>

                        <div *ngIf="rightFingers.length === 0" class="d-flex justify-content-start px-5">
                            <app-empty-list size="small" [isEmpty]="true"></app-empty-list>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <mat-dialog-actions align="end" class="mt-3">
        <button mat-button mat-dialog-close class="m-button-outlined s-md mr-2" [disabled]="isLoading">
            <mat-icon>close</mat-icon>{{ 'button.close' | translate }}
        </button>

        <button mat-button (click)="save()" class="m-button-primary s-md" [disabled]="isLoading || fingerprints.length === 0">
            <mat-icon>save</mat-icon>
            <span *ngIf="!isLoading">{{ 'button.save' | translate }}</span>
            <span *ngIf="isLoading">{{ 'general.waiting' | translate }}</span>
        </button>
    </mat-dialog-actions>
</div>
